import axios from "./axios";

class PGService {
  fpayCreateOrder = async (amount) => {
    try {
      const response = await axios.post("/pg/fp/create_order", {
        amount,
        channel: "WEB",
        qr: true,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fpCollectRequest = async (vpa_address, amount) => {
    try {
      const response = await axios.post("/pg/fp/collect_request", {
        vpa_address,
        amount,
        channel: "WEB",
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  txnStatus = async (order_id) => {
    try {
      const response = await axios.post("/pg/txn_status", { order_id });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  recentTransactions = async () => {
    try {
      const response = await axios.post("/pg/recent_transactions", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fetchAllBanks = async () => {
    try {
      const response = await axios.post("/pg/fetch_all_banks", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fundRequest = async (data) => {
    try {
      let config = {};
      let requestData = data;

      if (data instanceof FormData) {
        config = { headers: { "Content-Type": "multipart/form-data" } };
        requestData = data;
      } else {
        config = { headers: { "Content-Type": "application/json" } };
      }

      const response = await axios.post(
        "/pg/fund_request",
        requestData,
        config,
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new PGService();
